import { PropsWithChildren } from "react";
import ButtonLink from "@components/Button/components/Variant/ButtonLink";
import ButtonPrimary from "@components/Button/components/Variant/ButtonPrimary";
import ButtonSecondary from "@components/Button/components/Variant/ButtonSecondary";
import { ButtonFactoryProps, ButtonType } from "@components/Button/utils/types";

/** Factory component to choose which kind of button template to load. */
const createButton = (
  buttonType: ButtonType
): ((props: ButtonFactoryProps) => React.ReactElement) => {
  switch (buttonType) {
    case ButtonType.Primary:
      return ButtonPrimary;

    case ButtonType.Secondary:
      return ButtonSecondary;

    case ButtonType.Link:
    default:
      return ButtonLink;
  }
};

/** The default card component to be used in displaying articles in listing pages. */
const ButtonFactory = (
  props: PropsWithChildren<ButtonFactoryProps>
): React.ReactElement => {
  const Button = createButton(props.buttonType);

  return <Button {...props} />;
};

export default ButtonFactory;
